import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CloseButton, Modal } from 'react-bootstrap';
import CompanyForm from '../CompanyForm';
import { companyService } from 'services';
import { useMutation } from '@tanstack/react-query';
import useErrors from 'hooks/useErrors';
import { checkDomain } from 'helpers/utils';

const NewCompany = ({ show, setShow }) => {
 const [isLoading, setIsLoading] = useState(false);
 const { createCompany } = companyService.useApiCompany();

 const { setError } = useErrors();
 const { mutate } = useMutation(createCompany);

 const handleClose = () => setShow(false);

 const onError = err => console.log('se produjo un error ', err);

 const onSubmitData = async data => {
  setIsLoading(true);
  mutate(data, {
   onError: err => setError(err),
   //    onSettled: () => setIsLoading(false),
   onSuccess: async newData => {
    handleClose();
    const { hostname, port /* , replace */ } = window.location;
    const url = await checkDomain(hostname);
    localStorage.removeItem('sesion');
    return window.location.replace(
     `${port ? 'http://' : 'https://'}${[newData?.company?.subdomain, url.domain].join('.')}${port ? ':' + port : ''}/${
      newData?.token
     }/settings/company`
    );
   }
  });
 };

 return (
  <Modal size="lg" show={show} onHide={handleClose} className="mt-4 pb-4 pb-md-2">
   <Modal.Header className="px-4 py-2">
    <div className="">
     <h4 className="mb-0" id="authentication-modal-label">
      Crear Empresa
     </h4>
     <p className="fs--1 mb-0">Please create your free Falcon account</p>
    </div>
    <CloseButton className="position-absolute end-0 me-3 mt-3 top-0" onClick={handleClose} />
   </Modal.Header>
   <Modal.Body className="p-0">
    <CompanyForm isLoading={isLoading} onSubmitData={onSubmitData} onError={onError} />
   </Modal.Body>
  </Modal>
 );
};

NewCompany.propTypes = {
 show: PropTypes.bool,
 setShow: PropTypes.func
};

NewCompany.defaultProps = { show: false };

export default NewCompany;
